import widgetsMgr from 'widgets/widgetsMgr';

const hasContext = (context) => window.contexts.includes(context);

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('plp-price-slider'),
    load: () => Promise.all([
        import(/* webpackChunkName: 'search.widgets.slider' */ 'widgets/forms/InputStepper').then(d => d.default),
        import(/* webpackChunkName: 'comparison.widgets' */ './widgets/search/PriceSliderListingMixin').then(d => d.default),
        import(/* webpackChunkName: 'search.widgets.slider' */ './widgets/search/RefinementPriceRange').then(d => d.default),
        import(/* webpackChunkName: 'search.widgets.slider' */ './widgets/search/MultiThumbSlider').then(d => d.default)
    ]).then(deps => {
        const [
            InputStepper,
            PriceSliderListingMixin,
            RefinementPriceRange,
            MultiThumbSlider
        ] = deps;

        return {
            listId: 'search.widgets.slider',
            widgetsDefinition: () => [
                ['inputStepper', InputStepper, 'basicInput'],
                ['productListingMgr', PriceSliderListingMixin, 'productListingMgr'],
                ['refinementPriceRange', RefinementPriceRange],
                ['multiThumbSlider', MultiThumbSlider]
            ]
        };
    })
});
